import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/__auth/admin/profiles")({
    component: ProfilesLayout,
});

function ProfilesLayout() {
    return <Outlet />;
}
